module.exports = __webpack_public_path__ + "static/quaals_feather_token_anchor-895bc4bc5dc3fedc0a36bda95c3407de.jpeg";